import * as nodeUtils from "../../../../abstract/controller/utils/nodeUtils";
import * as pathUtils from '../../../../abstract/controller/utils/pathUtils'

export const showFunctionDrop = (srcElement, dstElement, root) => {
  const _srcId = nodeUtils.getID(srcElement);
  const _dstId = nodeUtils.getID(dstElement);

  if (!_srcId || _srcId === _dstId) {
    return false;
  }

  if (_dstId === pathUtils.getIdMarkerRoot()) {
    return true;
  }

  const _sibling = nodeUtils.getPreviousSiblingFunction(root, dstElement);

  return !_sibling || _sibling?.id !== _srcId;
};